import axios from 'axios';
import type { ProjectImportThread } from '@shared/models/project-import-task.model';
import type { ProjectFileClientUpload } from '@client/helpers/project-file-upload-normalize.helpers';

const path = (conversationId: string) => `/ai-chat/${conversationId}/imports`;
export const projectImportTasksApi = {
  read: (conversationId: string) =>
    axios
      .get<ProjectImportThread>(path(conversationId))
      .then((response) => response.data),
  upload: (
    conversationId: string,
    files: readonly ProjectFileClientUpload[],
  ) => {
    const form = new FormData();
    files.forEach((file) => form.append('files', file.file, file.relativePath));
    return axios
      .post<ProjectImportThread>(path(conversationId), form)
      .then((response) => response.data);
  },
  start: (conversationId: string, taskId: string) =>
    axios
      .post<ProjectImportThread>(`${path(conversationId)}/${taskId}/start`)
      .then((response) => response.data),
  discard: (conversationId: string, taskId: string) =>
    axios
      .delete<ProjectImportThread>(`${path(conversationId)}/${taskId}`)
      .then((response) => response.data),
};
